"use strict";
var React = require("react");
var { Modal, Button, ButtonToolbar, closeButton } = require("react-bootstrap");
var DepartmentForm = require("./DepartmentForm");

var AddDepartmentModal = React.createClass({
  onSubmit(event) {
    event.preventDefault();
    this.refs.departmentForm.onSubmit();
  },
  render: function() {
    return (
      <Modal id="addDepartmentModal" {...this.props} bsStyle='primary' animation={true}>
        <Modal.Header closeButton>
          <Modal.Title>Bæta við deild</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DepartmentForm ref="departmentForm" {...this.props} />
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar>
            <Button className="btn-success" onClick={this.onSubmit} type='submit'>Vista <i className="glyphicon glyphicon-ok"></i></Button>
            <Button onClick={this.props.onHide}>Hætta við</Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    );
  }
});

module.exports = AddDepartmentModal;



// WEBPACK FOOTER //
// ./app/scripts/ui/Settings/Departments/AddDepartmentModal.js